import { render, staticRenderFns } from "./ConsignmentSale.vue?vue&type=template&id=09813369&"
import script from "./ConsignmentSale.vue?vue&type=script&lang=js&"
export * from "./ConsignmentSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports